import { useEffect } from 'react';

import { BreedDialog } from 'entities/breed';

import { Breed } from 'shared/api';

type Props = {
  breed: Breed | null;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: Partial<Breed>) => void;
  isSuccess: boolean;
  isLoading: boolean;
};

export const EditBreed = ({ breed, isOpen, onClose, onSubmit, isSuccess, isLoading }: Props) => {
  useEffect(() => {
    if (isSuccess) onClose();
  }, [isSuccess, onClose]);

  return (
    <BreedDialog
      title="Edit breed"
      isOpen={isOpen}
      breed={breed ?? undefined}
      onClose={onClose}
      onSubmit={onSubmit}
      isLoading={isLoading}
    />
  );
};
